import { render, staticRenderFns } from "./PptAside.vue?vue&type=template&id=25bf868f&"
import script from "./PptAside.vue?vue&type=script&lang=js&"
export * from "./PptAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/PptAside.vue"
export default component.exports